<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <div class="form-group row">
            <div class="col-md-6">
                <div class="input-group">
                    <select class="form-control col-md-3" v-model="criterio">
                        <option value="email">Correo</option>
                        <option value="name">Nombre</option>
                        <option value="ip">IP</option>
                    </select>
                    <input
                        type="text"
                        v-model="search"
                        @keyup.enter="getListModelC()"
                        class="form-control"
                        placeholder="Texto a buscar"
                    />
                    <button
                        type="button"
                        @click="getListModelC()"
                        class="btn btn-primary"
                    >
                        <em class="fa fa-search"></em> Buscar
                    </button>
                </div>
            </div>
        </div>
        <table
            v-if="arrayModel.length > 0"
            class="table table-bordered table-striped table-sm"
        >
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Correo electrónico</th>
                    <th>IP</th>
                    <th>Fecha Creación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td v-html="model.name"></td>
                    <td v-html="model.email"></td>
                    <td v-html="model.ip"></td>
                    <td v-html="model.created_at"></td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePageC(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePageC(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePageC(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            criterio: "email",
            search: "",
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePageC(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModelC(page);
        },
        getListModelC(page = 1) {
            let me = this;
            let criterio = me.criterio;
            let search = me.search;
            axios
                .get(
                    "/api/treatment-personal-data/legals?page=" +
                        page +
                        "&criterio=" +
                        criterio +
                        "&search=" +
                        search
                )
                .then(function (response) {
                    const meses = [
                        "enero",
                        "febrero",
                        "marzo",
                        "abril",
                        "mayo",
                        "junio",
                        "julio",
                        "agosto",
                        "septiembre",
                        "octubre",
                        "noviembre",
                        "diciembre",
                    ];
                    const dias_semana = [
                        "domingo",
                        "lunes",
                        "martes",
                        "miércoles",
                        "jueves",
                        "viernes",
                        "sábado",
                    ];
                    response.data.models.data.forEach(function (valor, indice) {
                        let fecha = new Date(valor.created_at);
                        fecha.setHours(fecha.getHours() - 5);
                        fecha.toTimeString();
                        let hours = fecha.getHours();
                        let minutes = fecha.getMinutes();
                        let ampm = hours >= 12 ? "pm" : "am";
                        hours = hours % 12;
                        hours = hours ? hours : 12;
                        minutes = minutes < 10 ? "0" + minutes : minutes;
                        let time = hours + ":" + minutes + " " + ampm;
                        fecha =
                            dias_semana[fecha.getDay()] +
                            ", " +
                            fecha.getDate() +
                            " de " +
                            meses[fecha.getMonth()] +
                            " de " +
                            fecha.getUTCFullYear() +
                            ", " +
                            time;
                        response.data.models.data[indice].created_at = fecha;
                    });
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
    },
    mounted() {
        this.getListModelC();
    },
};
</script>
